// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31ef46f7","453":"ca959217","455":"02963139","977":"b9305838"}[chunkId] + ".chunk.js";
};